import { render } from "./Checkbox.vue?vue&type=template&id=bd608452&ts=true"
import script from "./Checkbox.vue?vue&type=script&lang=ts"
export * from "./Checkbox.vue?vue&type=script&lang=ts"

import "./Checkbox.vue?vue&type=style&index=0&id=bd608452&lang=scss"

import exportComponent from "C:\\Projects\\wordpress\\stadtwerke-bochum-gut-und-gruen-v2\\wp-content\\themes\\gut-und-gruen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__